import * as getCountries from './reducers/get';
import * as updateCountries from './reducers/update';
import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    COUNTRY_GET_REQUEST: getCountries.request,
    COUNTRY_GET_FINISH: getCountries.finish,
    COUNTRY_GET_ERROR: getCountries.error,

    COUNTRY_UPDATE_REQUEST: updateCountries.request,
    COUNTRY_UPDATE_FINISH: updateCountries.finish,
    COUNTRY_UPDATE_ERROR: updateCountries.error,
});
